export enum Constants {
  CAMPAIGN_SET_TOKEN_ADDRESS = 'CAMPAIGN_SET_TOKEN_ADDRESS',
  CAMPAIGN_SET_TITLE = 'CAMPAIGN_SET_TITLE',
  CAMPAIGN_SET_DESCRIPTION = 'CAMPAIGN_SET_DESCRIPTION',
  CAMPAIGN_SET_LOGO_URL = 'CAMPAIGN_SET_LOGO_URL',
  CAMPAIGN_SET_DROP_ADDRESS = 'CAMPAIGN_SET_DROP_ADDRESS',
  CAMPAIGN_SET_MERKLE_TREE = 'CAMPAIGN_SET_MERKLE_TREE',
  CAMPAIGN_SET_LOADING = 'CAMPAIGN_SET_LOADING',
  CAMPAIGN_SET_IPFS = 'CAMPAIGN_SET_IPFS',
  CAMPAIGN_SET_TYPE = 'CAMPAIGN_SET_TYPE',
  CAMPAIGN_SET_DECIMALS = 'CAMPAIGN_SET_DECIMALS',
  CAMPAIGN_CLEAR = 'CAMPAIGN_CLEAR',
  CAMPAIGN_SET_CAMPAIGN = 'CAMPAIGN_SET_CAMPAIGN',
  CAMPAIGN_SET_PREFERRED_WALLET_ON = 'CAMPAIGN_SET_PREFERRED_WALLET_ON',
  CAMPAIGN_SET_ASSETS = 'CAMPAIGN_SET_ASSETS',
  CAMPAIGN_SET_SYMBOL = 'CAMPAIGN_SET_SYMBOL',
  CAMPAIGN_SET_WALLET = 'CAMPAIGN_SET_WALLET',
  CAMPAIGN_SET_ADDITIONAL_WALLETS_ON = 'CAMPAIGN_SET_ADDITIONAL_WALLETS_ON',
  CAMPAIGN_SET_CLAIM_HOST = 'CAMPAIGN_SET_CLAIM_HOST',
  CAMPAIGN_SET_MULTIPLE_CLAIMS_ON = 'CAMPAIGN_SET_MULTIPLE_CLAIMS_ON',
  CAMPAIGN_SET_CLAIM_HOST_ON = 'CAMPAIGN_SET_CLAIM_HOST_ON',
  CAMPAIGN_SET_LAUNCH_STAGE = 'CAMPAIGN_SET_LAUNCH_STAGE',
  CAMPAIGN_SET_TRANSACTION_STAGE = 'CAMPAIGN_SET_TRANSACTION_STAGE',


  CAMPAIGN_SET_HANDLE_KEY = 'CAMPAIGN_SET_HANDLE_KEY',
  CAMPAIGN_SET_APP_ID = 'CAMPAIGN_SET_APP_ID',
  CAMPAIGN_SET_PROVIDER_ID = 'CAMPAIGN_SET_PROVIDER_ID',
  CAMPAIGN_SET_SECRET = 'CAMPAIGN_SET_SECRET',
  CAMPAIGN_SET_PROOF_PROVIDER = 'CAMPAIGN_SET_PROOF_PROVIDER',
  CAMPAIGN_SET_ZK_TLS_SERVICE = 'CAMPAIGN_SET_ZK_TLS_SERVICE',


  CAMPAIGN_SET_PROXY_CONTRACT_ADDRESS = 'CAMPAIGN_SET_PROXY_CONTRACT_ADDRESS',
  CAMPAIGN_SET_APPROVED = 'CAMPAIGN_SET_APPROVED',
  CAMPAIGN_SET_LINKS_GENERATE_LOADER = 'CAMPAIGN_SET_LINKS_GENERATE_LOADER',
  CAMPAIGN_SET_ID = 'CAMPAIGN_SET_ID',
  CAMPAIGN_SET_SECURED = 'CAMPAIGN_SET_SECURED',
  CAMPAIGN_SET_SIGNER_KEY = 'CAMPAIGN_SET_SIGNER_KEY',
  CAMPAIGN_SET_SIGNER_ADDRESS = 'CAMPAIGN_SET_SIGNER_ADDRESS',
  CAMPAIGN_SET_SPONSORED = 'CAMPAIGN_SET_SPONSORED',
  CAMPAIGN_SET_LINKS = 'CAMPAIGN_SET_LINKS',
  CAMPAIGN_SET_TOKEN_STANDARD = 'CAMPAIGN_SET_TOKEN_STANDARD',
  CAMPAIGN_SET_CLAIM_PATTERN = 'CAMPAIGN_SET_CLAIM_PATTERN',
  CAMPAIGN_SET_SDK = 'CAMPAIGN_SET_SDK',
  CAMPAIGN_SET_NATIVE_TOKENS_PER_LINK = 'CAMPAIGN_SET_NATIVE_TOKENS_PER_LINK',
  CAMPAIGN_SET_EXPIRATION_DATE = 'CAMPAIGN_SET_EXPIRATION_DATE',
  CAMPAIGN_SET_COUNTRIES_WHITELIST = 'CAMPAIGN_SET_COUNTRIES_WHITELIST',
  CAMPAIGN_SET_COLLECTION_ID= 'CAMPAIGN_SET_COLLECTION_ID',
  CAMPAIGN_SET_COLLECTION_TOKEN_ID= 'CAMPAIGN_SET_COLLECTION_TOKEN_ID',
  CAMPAIGN_SET_COUNTRIES_WHITELIST_ON = 'CAMPAIGN_SET_COUNTRIES_WHITELIST_ON'
}